import React, { useState } from "react";
import { Link } from "react-router-dom";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import whats from "../Images/Icons/whats.svg";

// import logo from "../Images/Logos/logo.png";
import logo from "../Images/Logos/3.png";

const drawerWidth = 240;
const navItems = [
  {
    name: "Sobre nosotros",
    url: "https://www.dslatamiswamexico.org",
    tipo: true,
  },
  { name: "Premiación", url: "#premiacion" },
  { name: "Contacto", url: "#contacto" },
];

const Header = (props) => {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{ textAlign: "center", height: "calc(100% - 80px)" }}
    >
      <Typography variant="h6" sx={{ my: 2 }}>
        <Link to={"/"} style={{ color: "#000000", textDecoration: "none" }}>
          <img src={logo} alt="DSlatam" style={{ width: "225px" }} />
        </Link>
      </Typography>
      <Divider />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <List>
          {navItems.map((item) => (
            <ListItem key={item.name} disablePadding>
              <ListItemButton>
                {item.tipo ? (
                  <a
                    style={{ color: "#000000", textDecoration: "none" }}
                    href={item.url}
                    target="_blanck"
                  >
                    {item.name}
                  </a>
                ) : (
                  <a
                    style={{ color: "#000000", textDecoration: "none" }}
                    href={item.url}
                  >
                    {item.name}
                  </a>
                )}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <div style={{ padding: "15px" }}>
          <a className="boton_3" target="_blanck" href="https://wa.link/4m06ig">
            <img src={whats} alt="WhatsApp" />
            Contáctanos
          </a>
        </div>
      </div>
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex", height: "64px" }}>
      <CssBaseline />
      <AppBar component="nav" sx={{ background: "#ffffff", boxShadow: "none" }}>
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Typography
            component="div"
            sx={{ mr: 2, display: { sm: "none" }, marginTop: "10px" }}
          >
            <Link to={"/"} style={{ color: "#000000", textDecoration: "none" }}>
              <img src={logo} alt="DSlatam" className="logo-header" />
            </Link>
          </Typography>

          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon sx={{ color: "#000" }} />
          </IconButton>

          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, display: { xs: "none", sm: "contents" } }}
          >
            <Link to={"/"} style={{ color: "#000000", textDecoration: "none" }}>
              <img src={logo} alt="DSlatam" className="logo-header" />
            </Link>
          </Typography>

          <Box sx={{ display: { xs: "none", sm: "flex" }, gap: "20px" }}>
            {navItems.map((item) =>
              item.tipo ? (
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={item.url}
                  target="_blanck"
                >
                  {item.name}
                </a>
              ) : (
                <a
                  style={{ color: "#000000", textDecoration: "none" }}
                  href={item.url}
                >
                  {item.name}
                </a>
              )
            )}
          </Box>
          <Typography
            component="div"
            sx={{ flexGrow: 1, display: { xs: "none", sm: "contents" } }}
          >
            <a
              className="boton_3"
              target="_blanck"
              href="https://wa.link/4m06ig"
            >
              <img src={whats} alt="WhatsApp" />
              Contáctanos
            </a>
          </Typography>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
};

export default Header;
